import { FC, RefObject, useCallback } from 'react';
import { styled } from '@mui/material/styles';

import { VAR_AREA_TOP } from '@mopla/constants';
import { Recaptcha, RecaptchaHandle } from '@mopla/ui';

import { environment } from '../../../environments/environment';

interface ISubscribeDTicketRecaptchaProps {
	recaptchaRef: RefObject<RecaptchaHandle>;
}

const StyledRecaptcha = styled(Recaptcha)(({ theme }) => ({
	'& .grecaptcha-badge': {
		bottom: 'unset !important',

		[theme.breakpoints.up('tabletP')]: {
			top: 80,
		},

		[theme.breakpoints.down('tabletP')]: {
			top: `calc(90px + ${VAR_AREA_TOP})`,
		},
	},
}));

export const SubscribeDTicketRecaptcha: FC<ISubscribeDTicketRecaptchaProps> = ({
	recaptchaRef,
}) => {
	const handleRecaptchaVerify = useCallback((token: string) => {
		// Token is handled via ref.executeRecaptcha() in the parent
		console.log('[SubscribeDTicketRecaptcha] Token verified');
	}, []);

	const handleRecaptchaError = useCallback(() => {
		console.error('[SubscribeDTicketRecaptcha] reCAPTCHA error');
	}, []);

	const handleRecaptchaExpired = useCallback(() => {
		console.warn('[SubscribeDTicketRecaptcha] reCAPTCHA expired');
		if (recaptchaRef.current) {
			recaptchaRef.current.resetRecaptcha();
		}
	}, [recaptchaRef]);

	return (
		<StyledRecaptcha
			ref={recaptchaRef}
			siteKey={environment.recaptchaSiteKey}
			onVerify={handleRecaptchaVerify}
			onError={handleRecaptchaError}
			onExpired={handleRecaptchaExpired}
			invisible
		/>
	);
};
